import * as _ from 'lodash';

import { Ng1StateDeclaration } from '@uirouter/angularjs';

import { ITaskService, IGroupService } from '../../services';
import { Group } from '../../models';

const states: Ng1StateDeclaration[] = [
    {
        name: 'taskProgress',
        url: '/taskProgress/:taskGuid',
        component: 'wtTaskProgressState',
        params: {
            configuration: null
        },
        resolve: {
            taskConfiguration: [
                '$q', '$stateParams', 'taskService', 'groupService',
                ($q: angular.IQService,
                    $stateParams,
                    taskService: ITaskService,
                    groupService: IGroupService) => {
                    const p = $stateParams['configuration']
                        ? $stateParams['configuration']
                        : taskService.getAll(false)
                            .then(data => {
                                return _.find(data, (d: any) => d.guid === $stateParams['taskGuid']);
                            });
                    let config;
                    return $q.when(p)
                        .then(data => {
                            config = data;
                            const p2 = data.groupGuid
                                ? groupService.getByGuid(data.groupGuid)
                                    .then(groupDto => groupDto.group)
                                : {};
                            return $q.when(p2);
                        })
                        .then((data: Group) => {
                            config.groupName = data.uniqueName;
                            config.count = config.dateCollection ? config.dateCollection.length : '';
                            return config;
                        });

                }
            ]
        },
        data: {
            sortingOrder: -1,
            icon: '',
            displayName: 'Task progress',
            editRoles: [],
            editButtonVisibility: () => false,
        }
    }];

export default states;